export default __webpack_public_path__ + "static/media/x_more_gray.357bc4a6.svg";